import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";
import { createPaginationModule, defaultPagination } from "@/store/common/pagination";

const wgInstancesPag = createPaginationModule('WORKGROUP_INSTANCES');

const state = {
    workgroupInstances: [],
    workgroupInstanceAuditLogs: [],
    pagination: defaultPagination(),
    loading: false,
    error: null,
};

const mutations = {
    ...wgInstancesPag.mutations,
    SET_WORKGROUP_INSTANCES(state, data) {
        state.workgroupInstances = data;
    },
    SET_WORKGROUP_INSTANCE_AUDIT_LOGS(state, data) {
        state.workgroupInstanceAuditLogs = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};

const actions = {
    async fetchWorkgroupInstances({ commit }, { workgroupId, includePast = false, limit = 10 }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.get(`/activity-workgroups/${workgroupId}/instances`, {
                params: {
                    include_past: includePast,
                    limit: limit,
                },
            });
            const data = response.data?.data?.instances || [];
            const pagination = response.data?.data?.pagination;

            commit("SET_WORKGROUP_INSTANCES", data);

            commit(wgInstancesPag.SET_PAGINATION, {
                currentPage: pagination.current_page,
                totalPages: pagination.total_pages,
                totalRecords: pagination.total_records,
                pageSize: pagination.page_size,
                hasPrevious: pagination.has_previous,
                hasNext: pagination.has_next,
            });

            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch workgroup instances");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async fetchWorkgroupInstanceAuditLogs({ commit }, aworkgroupinstanceid) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.post(`/managescheduleajax/`, {
                cmd: "getAIWGauditlogs",
                aworkgroupinstanceid: aworkgroupinstanceid,
            });
            const data = response.data?.data?.logs || [];
            commit("SET_WORKGROUP_INSTANCE_AUDIT_LOGS", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch workgroup instance audit logs");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },
};

const getters = {
    workgroupInstances: (state) => state.workgroupInstances,
    workgroupInstanceAuditLogs: (state) => state.workgroupInstanceAuditLogs,
    workgroupInstancesLoading: (state) => state.loading,
    workgroupInstancesError: (state) => state.error,
    workgroupInstancesPagination: (state) => state.pagination,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
